// extracted by mini-css-extract-plugin
export default {"root":"_GSODP","line":"lBLr4k"};